(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/primary-button.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/primary-button.js');
"use strict";


const Button = svs.ui.Button;
const PrimaryButton = _ref => {
  let children = _ref.children,
    onClick = _ref.onClick,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    className = _ref.className;
  return React.createElement(Button, {
    className: "payfooter-button ".concat(className),
    disabled: disabled,
    focus: true,
    onClick: onClick
  }, children);
};
svs.tur.ReactPayfooter.PrimaryButton = PrimaryButton;

 })(window);